import {Button} from '@/components/base/button/Button';
import {Typography, VARIANTS} from '@/components/base/typography/Typography';
import Image from '@/components/common/image/Image';
import {Section, SECTION_STYLES} from '@/components/common/section/Section';
import {useMessenger} from '@/components/page/vk-work-messenger/hooks';
import {Media, MediaContextProvider} from '@/media';

import mobileImage from './assets/bg-320.webp';
import desktopImage from './assets/bg-1024.webp';
import desktopXLImage from './assets/bg-1440.webp';
import styles from './DeviceAccess.module.css';

export function DeviceAccess() {
	const {handleOpenConnectionDialog} = useMessenger();

	return (
		<Section style={SECTION_STYLES.WITH_BREAKPOINTS} className={styles.root}>
			<div className={styles.block}>
				<div className={styles.textBlock}>
					<Typography as="h2" className={styles.title} variant={VARIANTS.h4}>
						Доступ с любого устройства
					</Typography>
					<Typography className={styles.text} variant={VARIANTS.text}>
						Используйте сервис «Опросы» в&nbsp;приложении VK&nbsp;Teams на&nbsp;компьютере,
						смартфоне и&nbsp;планшете или&nbsp;используйте веб-версию
					</Typography>
				</div>
				<Button className={styles.button} onClick={handleOpenConnectionDialog}>
					Оставить заявку
				</Button>
			</div>
			<div className={styles.imgWrap}>
				<MediaContextProvider>
					<Media className={styles.imgItem} lessThan="desktop">
						<Image src={mobileImage} layout="responsive" alt="Опросы" />
					</Media>
					<Media className={styles.imgItem} at="desktop">
						<Image src={desktopImage} width={436} height={256} alt="Опросы" />
					</Media>
					<Media className={styles.imgItem} greaterThanOrEqual="desktop_xl">
						<Image src={desktopXLImage} width={572} height={320} alt="Опросы" />
					</Media>
				</MediaContextProvider>
			</div>
		</Section>
	);
}
